// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".object-cover[data-v-1b18b322]{position:relative}.object-cover__copyright-info[data-v-1b18b322]{position:absolute;left:4px;bottom:0;z-index:10}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
